import { hotels_sections } from "./hotels-sections";
import {
  liveflight_sections,
  liveflight_sections_visitor,
} from "./liveflight-sections";
import { build_default_content } from "./utilities";
import { vivamod_sections } from "./vivamod-sections";

const content = {
  hotels: hotels_sections,
  vivamod: vivamod_sections,
  liveflight: liveflight_sections,
};

const not_authenticated_content = {
  liveflight: liveflight_sections_visitor,
};

/**
 * Restituisce il content builder appropriato per un determinato brand
 * Gestisce la logica di autenticazione per brand che hanno contenuti differenziati
 * per utenti autenticati e visitatori (es. liveflight)
 *
 * @param {string} brand - Identificativo del brand (es. "hotels", "vivamod", "liveflight")
 * @param {boolean} authenticated - Indica se l'utente è autenticato
 * @returns {Function} Funzione builder che accetta config e restituisce Array<Object> di blocchi sezione
 *
 * @example
 * // Ottenere il builder per un brand autenticato
 * const builder = get_brand_content_builder("liveflight", true);
 * const sections = builder(config);
 *
 * @example
 * // Per brand non riconosciuto, restituisce build_default_content
 * const builder = get_brand_content_builder("unknown", false);
 */
export const get_brand_content_builder = (brand, authenticated) => {
  const brand_key = (brand || "").toLowerCase();
  const brand_content = content[brand_key];
  if (!authenticated && not_authenticated_content[brand_key]) {
    return not_authenticated_content[brand_key];
  }
  return brand_content || build_default_content;
};

export * from "./utilities";
